import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label, EmptyItem } from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import { criarContribuinteDs } from "../../DataSources";
import { Button, ScrollView } from "devextreme-react";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import {
  Column,
  DataGrid,
  Paging,
  Selection,
} from "devextreme-react/data-grid";
import { LoadIndicator } from "devextreme-react/load-indicator";
import api from "../../api-axios";
import ShowError from "../../AppServices";

let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  prefeituraId: undefined,
  contribuinteId: undefined,
  listaCdas: [],
  popupVisivel: false,
  tipoPeriodo: 1,
  periodoCustomizado: "",
  loadIndicatorVisivel: false,
  texto: "Gerar CDA",
  continuarNestaTela: 2
};

export default class CdaForm extends React.Component {
  constructor(props) {
    super(props);

    this._formInstance = React.createRef();

    this.saidaProgramada = false;
    template.prefeituraId = UserInfo.getPrefeitura();
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.state = {
      ...(_cadastroCorrente || template),
      loadIndicatorVisivel: false,
      texto: "Gerar CDA",
    };
    this.contribuinteDs = criarContribuinteDs();
    this.cdasDs = [];
    this.onSelection = this.onSelection.bind(this);
    this._gridInstance = React.createRef();
    this.pesquisarDebitos = this.pesquisarDebitos.bind(this);


    //
    /* Funções do Contribuinte
     */
    this.setContribuinteId = this.setContribuinteId.bind(this);
    this.pesquisarContribuinte = this.pesquisarContribuinte.bind(this);
    this.onContribuinteSelecionadoPesquisa =
      this.onContribuinteSelecionadoPesquisa.bind(this);
    this.contribuinteBoxRef = React.createRef();
    this.renderContribuinte = sysCodigoDescricao(
      () => this.state.contribuinteId,
      this.setContribuinteId,
      () => this.state._uiNome,
      this.pesquisarContribuinte
    );

    //
    /* Fim das funções do Contribuinte
     */

    this.tipoPeriodoAlterado = this.tipoPeriodoAlterado.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);


    this.filtroOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 0, descricao: "NENHUM" },
        { id: 1, descricao: "EXERCICIO - ULTIMOS 5 ANOS" },
        { id: 2, descricao: "VENCIMENTO - ULTIMOS 5 EXERCÍCIOS" },
        { id: 3, descricao: "VENCIMENTO - ULTIMOS 5 ANOS" },
        // { id: 4, descricao: "EXERCICIO CUSTOMIZADO" },
        // { id: 5, descricao: "VENCIMENTO - CUSTOMIZADO" },

      ],
      placeholder: " ",
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: false,
      onValueChanged: this.tipoPeriodoAlterado
    };

    this.continuarNestaTelaOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 1, descricao: "SIM" },
        { id: 2, descricao: "NÃO" },
      ],
      placeholder: " ",
      valueExpr: "id",
      displayExpr: "descricao",
      showClearButton: false,

    };
  }

  tipoPeriodoAlterado(e) {
    console.log("form instance", this._formInstance);
    this.setState({ tipoPeriodo: e.value });
    this._formInstance.instance.repaint();

  }


  //
  /* Funções do Contribuinte
   */

  setContribuinteId(data) {
    if (data.value == "" || data.value == undefined) {
      this.setState({ items: [], contribuinteId: null });
      return;
    }

    let estado = {};
    Object.assign(estado, this.state);
    this.contribuinteDs
      .load({ filter: [["sequencial", "=", data.value]] })
      .then((result) => {
        if (result.length !== 0) {
          if (result[0] === undefined) {
            Object.assign(estado, { _uiNome: "" });
          } else {
            Object.assign(estado, { _uiNome: result[0].nome });
          }
        } else {
          Object.assign(estado, { _uiNome: "" });
        }
        this.setState({
          ...estado,
          contribuinteId: data.value,
          popupVisivel: false,
        });
      })
      .catch((_) => this.setNomeContribuinteErro());
  }


  limparFiltro() {
    this.setState({ ...template });
    this._formInstance.instance.repaint();
  }

  pesquisarDebitos() {
    console.log("state", this.state);

    let contribuinteId;
    try {
      contribuinteId = parseInt(this.state.contribuinteId);
    } catch { }

    if (contribuinteId == undefined || contribuinteId == 0) {
      this.setState({ items: [] });
      return;
    }
    const url = `/cda/debitos_contribuinte/${UserInfo.getPrefeitura()}`;

    const request = {
      contribuinteId: contribuinteId,
      tipoPeriodo: this.state.tipoPeriodo,
      periodoCustomizado: this.periodoCustomizado
    };

    console.log("request cda", request);
    api
      .post(url, request)
      .then((resp) => {
        console.log("resp", resp);
        const data = resp.data.length > 0 ? resp.data[0].itens : [];
        this.setState({ items: data });
      })
      .catch((error) => console.log("resp error", error.response));
  }

  setNomeContribuinteErro() {
    this.setState({ _uiNomeContribuinte: "<<ERRO>>" });
  }

  onContribuinteSelecionadoPesquisa(e) {
    let data = {};
    Object.assign(data, { value: e.row.data.sequencial.toString() });
    this.setContribuinteId(data);
  }

  pesquisarContribuinte() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.setState({ popupVisivel: true });
  }

  //
  /* Fim das funções do Contribuinte
   */

  componentDidMount() {
    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.cdasDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (data == undefined) {
              notify("Taxa não encontrada.", "error");
              this.props.history.push("/cda");
            }
            this.setState(data);
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      }
    } else {
      this.setState({ ..._cadastroCorrente });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    if (this.props.match.params.id !== undefined) {
      _cadastroCorrente = _cancelando ? undefined : this.state;
    }
  }

  onSelection(e) {
    this.setState({ listaCdas: e.selectedRowsData });
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} ref={form => this._formInstance = form} >
              <GroupItem caption="GERAR CDA" colCount={4}>

                <SimpleItem colSpan={4} component={this.renderContribuinte}>
                  <Label text="Contribuinte" />
                </SimpleItem>

                <SimpleItem dataField={"tipoPeriodo"} editorType={"dxSelectBox"} editorOptions={this.filtroOptions} colSpan={2}>
                  <Label text="Tipo de Período" />
                </SimpleItem>

                <SimpleItem dataField={"periodoCustomizado"} visible={this.state.tipoPeriodo >= 4} colSpan={2}>
                  <Label text="Período" />
                </SimpleItem>


                <SimpleItem dataField={"continuarNestaTela"} editorType={"dxSelectBox"} editorOptions={this.continuarNestaTelaOptions} colSpan={2}>
                  <Label text="Permanecer nesta tela" />
                </SimpleItem>


              </GroupItem>
            </Form>

            <div
              style={{
                marginTop: "10px",
                marginBottom: "15px",
                display: "flex",
                justifyContent: "left",
              }}
            >
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Filtrar"
                  type="success"
                  onClick={this.pesquisarDebitos}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Limpar Filtro" onClick={this.limparFiltro} />
              </div>
            </div>

            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.state.items}
              showBorders={true}
              rowAlternationEnabled={true}
              columnAutoWidth={true}
              wordWrapEnabled={true}
              onSelectionChanged={(e) => this.onSelection(e)}
            >
              <Selection
                mode="multiple"
                selectAllMode="allPages"
                showCheckBoxesMode="always"
              />
              <Column dataField={"dividaSequencial"} caption={"#"} width={90} />
              <Column
                dataField={"tributaria"}
                caption={"Tributária"}
                dataType={"boolean"}
                width={90}
              />
              <Column
                dataField={"exercicio"}
                caption={"Exercício"}
                width={90}
              />

              <Column dataField={"imovelId"} caption={"Imóvel"} width={90}/>

              <Column
                dataField={"vencimento"}
                caption={"Vencimento"}
                dataType={"date"}
                width={90}
              />
              <Column
                dataField={"origem"}
                caption={"Origem"}
                width={80}
              ></Column>
              <Column
                dataField={"valorOriginal"}
                caption={"Vr. Original (R$)"}
                format={{ type: "fixedPoint", precision: 2 }}
                width={110}
              />
              <Column
                dataField={"multa"}
                caption={"Multa (R$)"}
                format={{ type: "fixedPoint", precision: 2 }}
                width={110}
              />
              <Column
                dataField={"juros"}
                caption={"Juros (R$)"}
                format={{ type: "fixedPoint", precision: 2 }}
                width={110}
              />
              <Column
                dataField={"correcao"}
                caption={"Correção (R$)"}
                format={{ type: "fixedPoint", precision: 2 }}
                width={110}
              />
              <Column
                dataField={"total"}
                caption={"Total (R$)"}
                format={{ type: "fixedPoint", precision: 2 }}
                width={125}
              />

              <Column dataField={"imovelEndereco"} caption={"Endereço"} />
              <Paging enabled={false} />
            </DataGrid>
            <div
              style={{
                display: "flex",
                marginTop: "25px",
                justifyContent: "center",
                alignContent: "center",
                justifyItems: "center",
                alignItems: "center",
              }}
            >
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  width={160}
                  style={{ display: "inline-block", justifyContent: "center" }}
                  type="success"
                  onClick={this.ok}
                  disabled={this.state.loadIndicatorVisivel}
                >
                  <LoadIndicator
                    className="button-indicator"
                    id="small-indicator"
                    height={20}
                    width={20}
                    visible={this.state.loadIndicatorVisivel}
                    style={{ marginRight: "10px", verticalAlign: "middle" }}
                  />
                  <span className="dx-button-text">{this.state.texto}</span>
                </Button>
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button width={160} text="Voltar" onClick={this.cancel} />
              </div>
            </div>
          </form>
          <Popup
            visible={this.state.popupVisivel}
            onHiding={() => this.setState({ popupVisivel: false })}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Contribuinte"
          >
            <ScrollView showScrollbar={"always"}>
              <ContribuinteBox
                onSelecionado={this.onContribuinteSelecionadoPesquisa}
                ref={this.contribuinteBoxRef}
              />
            </ScrollView>

            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    this.setState(
      {
        loadIndicatorVisivel: true,
        texto: "Gerando CDA...",
      },
      () => {
        const request = {
          contribuinteId: this.state.contribuinteId,
          prefeituraId: UserInfo.getPrefeitura(),
          itens: this.state.listaCdas,
        };

        api
          .post("/cda/gerar_cda/", request)
          .then((_) => {
            this.setState(
              {
                loadIndicatorVisivel: false,
                texto: "Gerar CDA",
              },
              (_) => this.pesquisarDebitos()
            );
          })
          .catch((error) => {
            if (
              error.response &&
              error.response.data &&
              error.response.data.erros
            ) {
              ShowError(error.response.data.erros);
            } else {
              ShowError(error.message);
            }
            this.setState({
              loadIndicatorVisivel: false,
              texto: "Gerar CDA",
            });
          })
          .finally((_) => { });
      }
    );
    //const request = { listaCdas: this.state.listaCdas, prefeituraId: UserInfo.getPrefeitura() };
    //showReport("/reports/cda", request);
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    this.props.history.goBack();
  }
}
